export default "__VITE_ASSET__Mh4BwEFo__"